import React from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormSectionCard } from 'components/_basic/FormSectionCard';

import { TotalExpensesFormHeader } from './components/TotalExpensesFormHeader';
import { TotalExpensesFormTable } from './components/TotalExpensesFormTable';
import { FullScreenWrapper } from '../../components/FullScreenWrapper';

const FormComponent = ({ disabled }: { disabled: boolean }) => {
  return (
    <>
      <TotalExpensesFormHeader disabled={disabled} />
      <TotalExpensesFormTable disabled={disabled} />
    </>
  );
};

export const TotalExpensesForm: React.FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES,
  );

  return (
    <>
      <FormSectionCard collapsible title={t('financialPlan.plannedExpenses.totalExpenses.title')} disabled={!canAccess}>
        <FullScreenWrapper title={t('financialPlan.plannedExpenses.totalExpenses.title')}>
          <FormComponent disabled={!canAccess} />
        </FullScreenWrapper>
      </FormSectionCard>
    </>
  );
};
